import getApiClient from '@/plugins/api'

export default {
  loadPage() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`pages/${itemId}`)
      .then((result) => {
        self.page = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },
}
